import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { ProductGrid } from "../components/ProductCard";
import { PageHead } from "./Shop";
import { DISCOVER } from "../components/CategoryMenu";
import { tx, useLang } from "../lib/i18n";
import { PageLoading } from "../components/PageLoading";

const EMPTY = {
  "flash-deals": "No flash deals are running right now.",
  "best-sellers": "Best sellers appear here once real (non-sandbox) orders are completed.",
  "mivo-exclusive": "MIVO Exclusive products will appear here once they are published.",
  sale: "No products are on sale right now. MIVO never shows invented previous prices.",
  trending: "Not enough browsing activity yet to show trends.",
  "recently-viewed": "Products you view will appear here.",
  "bulk-deals": "No bulk or minimum-quantity deals are listed yet.",
};

export default function Discover() {
  const lang = useLang();
  const { key } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => {
    setD(null);
    const ids = key === "recently-viewed" ? JSON.parse(localStorage.getItem("mivo_recent") || "[]").join(",") : undefined;
    api.get(`/discover/${key}`, { params: { ids: ids || undefined } }).then((r) => setD(r.data)).catch(() => setD({ products: [], note: null }));
  }, [key, lang]);
  const meta = DISCOVER.find(([k]) => k === key);
  return (
    <div className="mv-container pb-16" data-testid="discover-page">
      <PageHead eyebrow={tx("SHOP COLLECTIONS")} title={tx(meta ? meta[1] : "Collection")}>
        {d?.note && <p className="mt-3 text-sm text-[var(--mv-muted)]" data-testid="discover-note">{tx(d.note)}</p>}
      </PageHead>
      <div className="mb-8 flex flex-wrap gap-2" data-testid="discover-tabs">
        {DISCOVER.map(([k, l]) => (
          <Link key={k} to={`/discover/${k}`} data-testid={`discover-tab-${k}`}
            className={`rounded-full border px-3.5 py-2 text-[13px] ${k === key ? "border-[var(--mv-teal)] bg-[var(--mv-teal-dim)] text-[var(--mv-teal)]" : "border-[var(--mv-border-2)] text-[var(--mv-muted)] hover:text-[var(--mv-text)]"}`}>{tx(l)}</Link>
        ))}
      </div>
      {!d ? <p className="text-sm text-[var(--mv-muted)]"><PageLoading /></p> : d.products.length ? <ProductGrid items={d.products} /> : (
        <div className="rounded-2xl border border-dashed border-[var(--mv-border-2)] p-12 text-center text-[var(--mv-muted)]" data-testid="discover-empty">
          {tx(EMPTY[key] || "Nothing here yet.")}
          <div><Link to="/shop" className="mt-4 inline-block text-sm text-[var(--mv-teal)]">{tx("Browse all products")} →</Link></div>
        </div>
      )}
    </div>
  );
}
